interface ToastDescriptor
{
	body: Array<HTMLElement|JQuery<HTMLElement>|Text|string>;
	position?: number;
	timeout?: number;
	context?: ui.Context;
}

interface NotifyDescriptor extends ToastDescriptor
{
	title: Array<HTMLElement|JQuery<HTMLElement>|Text|string>;
}

class Toast
	extends ui.pattern.observer.Observer
{
	protected	element: HTMLElement;
	protected	manager: ToastManager;
	protected	close: JQuery;
	protected	timeout_idx: number;

	private		top: number;

	constructor(
		descriptor: ToastDescriptor,
		manager: ToastManager,
	)
	{
		super();

		this.timeout_idx = 0;
		this.manager = manager;
		this.top = 0;

		if ( descriptor.position )
		{
			this.top = descriptor.position;
		}

		this.element = document.createElement( 'div' );
		const doc = $( document.createElement( 'div' ) );

		$( this.element ).addClass( 'toast box' );
		$( this.element ).css( { "top": this.top + 'px', 'border-radius': 0, "border": 0, "padding": 3 } );

		if ( descriptor.context )
		{
			$( this.element ).addClass( 'bg-' + descriptor.context );
		}

		doc.attr( 'role', 'document' );
		doc.addClass( 'toast-body' );

		this.close = $( document.createElement( 'button' ) );

		this.close.attr( 'type', 'button' );
		this.close.addClass( 'close' );
		this.close.attr( 'aria-label', 'Close' );
		this.close.html( '&times;' );

		const man = manager;

		this.close.on( 'click', () => man.remToast( this ) );

		if ( descriptor.timeout )
		{
			this.timeout_idx	= setTimeout( () => man.remToast( this ), descriptor.timeout );
		}

		doc.append( this.close );

		for ( const i in descriptor.body )
		{
			doc.append( descriptor.body[ i ] );
		}

		$( this.element ).append( doc );
	}

	public update( data: any ) : void
	{
		if ( data.index < this.getIndex() )
		{
			this.top -= data.height;

			$( this.element ).css( 'top', this.top + 'px' );
		}
	}

	public getElement() : HTMLElement
	{
		return this.element;
	}

	public hideToast()
	{
		const e = $( this.element ).height() || 15;

		const man = this.manager;
		const param = { index: this.getIndex(), height: e };

		try
		{
			if ( this.timeout_idx != null )
			{
				clearTimeout( this.timeout_idx );
			}
		}
		catch ( e )
		{}
		finally
		{
			const _this_: JQuery = $( this.element );
			$( this.element ).fadeOut(
				"slow",
				function()
				{
					_this_.remove();

					man.notify( param );
				},
			);
		}
	}
}

class Notify
	extends Toast
{

	public constructor( descriptor: NotifyDescriptor, manager: ToastManager )
	{
		super( descriptor, manager );

		this.close.remove();

		const header = $( document.createElement( 'div' ) );

		header.addClass( 'toast-header' );

		header.append( this.close );

		const notify = this;
		const man = this.manager;
		this.close.on(
			'click',
			function()
			{
				man.remToast( notify );
			},
		);

		for ( const i in descriptor.title )
		{
			header.append( descriptor.title[ i ] );
		}

		this.element.insertBefore( header[ 0 ], this.element.children.item( 0 ) );

		$( this.element ).on(
			{
				mouseenter: () =>
				{
					try
					{
						clearTimeout( this.timeout_idx );
					} catch (_) {}
				},
				mouseleave: () =>
				{
					this.timeout_idx	= setTimeout( () => man.remToast( this ), descriptor.timeout);
				},
			},
		);
	}

}

class ToastManager
	extends ui.pattern.observer.Subject
{
	private element: JQuery;
	private top: number;
	private min_top: number;

	constructor( top: number = 60 )
	{
		super();

		this.min_top = top;
		this.top = top;
		this.element = $( document.createElement( 'div' ) );

		this.element.attr( 'id', 'TOAST_MANAGER_PLANE' );
		this.element.css( 'background-color', 'transparent' );
		this.element.addClass("hidden");

		$( document.body ).append( this.element );
	}

	public addToast( toast: ToastDescriptor )
	{
		if ( !toast || !toast.body )
		{
			return;
		}
		this.element.removeClass("hidden");

		toast.position = this.Top();

		const t = new Toast( toast, this );

		this.register( t );

		this.element.append( t.getElement() );

		const e = $( t.getElement() ).outerHeight();

		if ( e ) { this.top += e + 15; }
	}

	public addNotify( notify: NotifyDescriptor )
	{
		if ( !notify || !notify.title || !notify.body )
		{
			return;
		}
		this.element.removeClass("hidden");

		notify.position = this.Top();

		const t = new Notify( notify, this );

		this.register( t );

		this.element.append( t.getElement() );

		const e = $( t.getElement() ).outerHeight();

		if ( e ) { this.top += e + 15; }
	}

	public remToast( toast: Toast ) : void
	{
		const e = $( toast.getElement() ).outerHeight();

		if ( e ) { this.top -= e + 15 < this.top ? this.top : e + 15; }

		if ( !this.unregister( toast ) )
		{
			return;
		}

		toast.hideToast();
	}

	private Top() : number
	{
		if ( this.top < this.min_top )
		{
			this.top = this.min_top;
		}

		return this.top;
	}

	public notify(data?: any) {
		super.notify(data);

		if(this.element.find(".toast").length > 0){
			this.element.removeClass("hidden");
		}
		else {
			this.element.addClass("hidden");
		}
	}
}
